<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-calculator"></i></span>{{ 'FreightField.Other.FreightEstimate' | translate }}
  </h1>
  <p-card>
    <!--sm / md / lg / xl-->
    <div class="p-fluid formgrid grid">
      <div class="field lg:col-4 sm:col-12">
        <label>{{ "FreightField.Facility" | translate }}</label>
        <p-dropdown
          [filter]="true"
          [options]="facilityOptions"
          [(ngModel)]="searchParams.facility"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
        >
        </p-dropdown>
      </div>
      <div class="field lg:col-4 sm:col-12">
        <label>{{ 'FreightField.Other.ShippingType' | translate }}</label>
        <p-dropdown [filter]="true" [options]="shippingTypeOptions" [(ngModel)]="searchParams.shippingType"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
        </p-dropdown>
      </div>
      <div class="field lg:col-4 sm:col-12">
        <label><span class="requiredStart">*</span>{{ 'FreightField.Other.ShipTerm' | translate }}</label>
        <p-dropdown [filter]="true" [options]="incoTermList" [(ngModel)]="searchParams.incoTerm"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
        </p-dropdown>
      </div>
    </div>

    <!--起訖點-->
    <div class="p-fluid formgrid grid">
      <div class="field col-12">
        <h3 style="margin: 0 auto;">{{ 'FreightField.Other.FromandTo' | translate }}</h3>
      </div>

      <div class="field lg:col-6 sm:col-12">
        <label><span class="requiredStart">*</span>{{ 'FreightField.Other.OriginCountry' | translate }}</label>
        <p-dropdown [filter]="true" [options]="countryList" [(ngModel)]="searchParams.fromCountry"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}" (onChange)="getFromCityOptions('from')"
          [class]="vaildFromCountry ? ['ng-invalid', 'ng-dirty'] : []">
        </p-dropdown>
      </div>
      <div class="field lg:col-6 sm:col-12">
        <label><span class="requiredStart">*</span>{{ 'FreightField.Other.OriginCity' | translate }}</label>
        <p-dropdown [filter]="true" [options]="cityListFrom" [(ngModel)]="searchParams.fromCity"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}" (onChange)="getFromCity('from')"
          [class]="vaildFromCountry ? ['ng-invalid', 'ng-dirty'] : []">
        </p-dropdown>
      </div>
      <div class="field lg:col-6 sm:col-12">
        <label><span class="requiredStart">*</span>{{ 'FreightField.Other.DestinationCountry' | translate }}</label>
        <p-dropdown [filter]="true" [options]="countryList" [(ngModel)]="searchParams.toCountry"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}" (onChange)="getFromCityOptions('to')"
          [class]="vaildToCountry ? ['ng-invalid', 'ng-dirty'] : []">
        </p-dropdown>
      </div>
      <div class="field lg:col-6 sm:col-12">
        <label><span class="requiredStart">*</span>{{ 'FreightField.Other.DestinationCity' | translate }}</label>
        <p-dropdown [filter]="true" [options]="cityListTo" [(ngModel)]="searchParams.toCity"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}" (onChange)="getFromCity('to')"
          [class]="vaildToCountry ? ['ng-invalid', 'ng-dirty'] : []">
        </p-dropdown>
      </div>
    </div>

    <!--材積/重量-->
    <div class="p-fluid formgrid grid">
      <div class="field col-12">
        <label>{{ 'FreightField.Other.VolumnGrosWeight' | translate }}</label>
      </div>
      <div class="field lg:col-6 sm:col-12">
        <label>{{ 'FreightField.Other.totalGrossWeight' | translate }}</label>
        <p-inputNumber [minFractionDigits]="2" [maxFractionDigits]="2" [inputStyle]="{'width': '100%'}" mode="decimal"
          [(ngModel)]="searchParams.totalGrossWeight">
        </p-inputNumber>
      </div>
      <div class="field lg:col-6 sm:col-12">
        <label>{{ 'FreightField.Other.totalVolumeWeight' | translate }}</label>
        <p-inputNumber [minFractionDigits]="2" [maxFractionDigits]="2" [inputStyle]="{'width': '100%'}" mode="decimal"
          [(ngModel)]="searchParams.totalVolumeWeight">
        </p-inputNumber>
      </div>
    </div>

    <div class="grid">
      <div class="col">
        <button #OperationLog pButton pRipple label="{{ 'Common.Button.Search' | translate }}"
          (click)="searchClickBtn($event)"></button>
        <button #OperationLog pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-2"
          (click)="resetClickBtn($event)"></button>
        <button
          pButton
          pRipple
          label="{{ 'Common.Button.Export' | translate }}"
          class="p-ml-2"
          (click)="exportResult()"
        ></button>
      </div>
    </div>

    <laas-data-table class="hidden md:block" [tableKey]="preferenceKey" [selectable]="true" [(selectedRows)]="selectedRow"
      [dataKey]="'seqNo'" [value]="freightTrialCalculationResult" [defaultColumns]="tableColumns" [loading]="isLoading">
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'deliveryMode'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: shippingTypeOptions | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCountry'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: countryList | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fromCity'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: cityListFrom | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toCountry'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: countryList | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'toCity'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping: cityListTo | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'freight'">
              <div class="overflow-text">
                {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'fuelCosts'">
              <div class="overflow-text">
                {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'securityCheckFee'">
              <div class="overflow-text">
                {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'otherFee'">
              <div class="overflow-text">
                {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'estimateTotalCharge'">
              <div class="overflow-text">
                {{ rowData[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
    </laas-data-table>

    <laas-data-view class="block md:hidden" [value]="freightTrialCalculationResult">
      <ng-template let-result pTemplate="listItem">
        <div class="field col-12">
          <div class="p-fluid grid laas-list-item">
            <ng-container *ngFor="let col of tableColumns">
              <div class="field col-6 md:col-3 lg:col-2 mb-0 text-right">
                <label class="font-bold mb-0">{{ col.field | translate }}</label>
              </div>
              <div class="field col-6 md:col-3 lg:col-2 mb-0" [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'deliveryMode'">
                  <div class="overflow-text">
                    {{ result[col.field] | optionsMapping: shippingTypeOptions | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'freight'">
                  <div class="overflow-text">
                    {{ result[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'fuelCosts'">
                  <div class="overflow-text">
                    {{ result[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'securityCheckFee'">
                  <div class="overflow-text">
                    {{ result[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'otherFee'">
                  <div class="overflow-text">
                    {{ result[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'estimateTotalCharge'">
                  <div class="overflow-text">
                    {{ result[col.field] | number: '1.0-14' | replaceNullWith: '-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ result[col.field] }}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </laas-data-view>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
